import { useSuppliers } from '../hooks/useSuppliers';
import { CreateSupplierDialog } from '../components/suppliers/CreateSupplierDialog';
import { SuppliersTable } from '../components/suppliers/SuppliersTable';
import { LoadingAnimation } from '@/shared/components/LoadingAnimation';

export const SupplierManagement = () => {
  const { data: suppliers, isLoading, error } = useSuppliers();

  if (isLoading) {
    return <LoadingAnimation fullScreen />;
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4">
        <p className="text-red-600">Failed to load suppliers</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Suppliers</h1>
          <p className="text-gray-500 mt-1">
            Manage suppliers and their information
          </p>
        </div>
        <CreateSupplierDialog />
      </div>

      <SuppliersTable suppliers={suppliers || []} />
    </div>
  );
};